/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './index.css';

const RangePicker = ({ onChange }) => {
  const [startDate, setStartDate] = useState(moment().startOf('d').toDate());
  const [endDate, setEndDate] = useState(moment(startDate).endOf('d').add(2, 'd').toDate());

  useEffect(() => {
    onChange(startDate, endDate);
  }, []);

  return (
    <div className='date-range-picker'>
      <div className='date-picker-element'>
        <label htmlFor='desde'>
          Desde:
        </label>
        <DatePicker
          placeholder='Desde'
          name='desde'
          id='desde'
          selected={startDate}
          onChange={(date) => {
            const newStartDate = moment(date).startOf('d').toDate();
            setStartDate(newStartDate);
            if (moment(endDate).startOf('d').subtract(2, 'd').unix() < moment(date).startOf('d').add(1, 'd').unix()) {
              setEndDate(moment(date).endOf('d').add(2, 'd').toDate());
              onChange(newStartDate, moment(date).endOf('d').add(2, 'd').toDate());
            } else {
              onChange(newStartDate, endDate);
            }
          }}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          minDate={moment().startOf('d').toDate()}
        />
      </div>
      <div className='date-picker-element'>
        <label htmlFor='hasta'>
          Hasta:
        </label>
        <DatePicker
          placeholder='Hasta'
          id='hasta'
          name='hasta'
          selected={endDate}
          onChange={(date) => {
            const newEndDate = moment(date).endOf().toDate();
            setEndDate(newEndDate);
            onChange(startDate, newEndDate);
          }}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={moment(startDate).startOf('d').add(2, 'd').toDate()}
        />
      </div>
    </div>
  );
};

export default RangePicker;
